import React from 'react';
import { FaStar, FaAward, FaHeart } from 'react-icons/fa';
import { useTranslation } from '../../context/LanguageContext';
import Person from '../../assets/images/team.webp';

/**
 * Home — About the clinic.
 * Photo on the left, badge + headline + paragraph + 3 feature mini-cards on the right.
 */
export const HomeAboutSection = () => {
    const { t } = useTranslation();

    const features = [
        { icon: <FaStar className="text-gold" />, title: t('about.feature1Title'), text: t('about.feature1Text') },
        { icon: <FaAward className="text-gold" />, title: t('about.feature2Title'), text: t('about.feature2Text') },
        { icon: <FaHeart className="text-gold" />, title: t('about.feature3Title'), text: t('about.feature3Text') },
    ];

    return (
        <section id="about" className="py-14 sm:py-18 md:py-24 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col lg:flex-row lg:items-center gap-10 md:gap-14 lg:gap-20">
                    {/* Image */}
                    <div className="w-full sm:w-2/3 md:w-1/2 lg:w-5/12 mx-auto lg:mx-0 flex-shrink-0">
                        <div className="relative">
                            <div className="absolute -top-4 -left-4 w-full h-full bg-gold/20 rounded-2xl" />
                            <img
                                className="relative w-full h-auto rounded-2xl shadow-xl"
                                src={Person}
                                alt={t('about.badge')}
                                width={1792}
                                height={2380}
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                    </div>
                    {/* Text */}
                    <div className="flex-1 flex flex-col justify-center">
                        <span className="inline-block px-4 py-1.5 bg-gold/10 text-gold font-semibold text-sm rounded-full mb-4 w-fit mx-auto lg:mx-0">
                            {t('about.badge')}
                        </span>
                        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 leading-tight mb-6 text-center lg:text-left">
                            {/* Space kept inside the expression = one text node. */}
                            {`${t('about.title')} `}
                            <span className="text-gold">{t('about.titleHighlight')}</span>
                        </h2>
                        <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed mb-8 text-left">
                            {t('about.text1')}
                        </p>

                        {/* Feature mini-cards */}
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                            {features.map(({ icon, title, text }) => (
                                <div key={title} className="flex flex-col items-center sm:items-start text-center sm:text-left p-4 bg-gray-50 rounded-xl">
                                    <span className="text-2xl mb-2">{icon}</span>
                                    <h4 className="text-sm font-bold text-gray-800 mb-1">{title}</h4>
                                    <p className="text-xs text-gray-500">{text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

